// Schemas Zod para Notifications. Backend doc canonico: `docs/api/notifications.md`.
//
// Cobrem parse-on-boundary das respostas (api.ts faz `.parse()`):
//   - notificationSchema -> shape camelCase de cada notificacao
//   - notificationPreferencesSchema -> shape camelCase das preferencias
//   - markReadAllResponseSchema -> { marked: number } do PATCH /read-all

import { z } from 'zod';

import { NOTIFICATION_TYPES } from '@/shared/config/constants';

export const notificationTypeSchema = z.enum(NOTIFICATION_TYPES);

export const notificationSchema = z.object({
  id: z.string(),
  userId: z.string().nullable(),
  title: z.string(),
  message: z.string(),
  type: notificationTypeSchema,
  data: z.record(z.string(), z.unknown()).nullable(),
  createdAt: z.string(),
  readAt: z.string().nullable(),
});

export const notificationPreferencesSchema = z.object({
  id: z.string(),
  userId: z.string(),
  dueDateReminder: z.boolean(),
  goalReached: z.boolean(),
  budgetExceeded: z.boolean(),
  systemUpdates: z.boolean(),
  emailEnabled: z.boolean(),
  smsEnabled: z.boolean(),
  pushEnabled: z.boolean(),
  // Os 4 toggles de grupo familiar podem nao existir em backends antigos —
  // default `true` mantem o comportamento de "todos ativos por padrao".
  familyGroupSettlementCreated: z.boolean().default(true),
  familyGroupSettlementDeleted: z.boolean().default(true),
  familyGroupContributionUpdated: z.boolean().default(true),
  familyGroupMemberForceRemoved: z.boolean().default(true),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const markReadAllResponseSchema = z.object({
  marked: z.number().int().nonnegative(),
});

export type NotificationParsed = z.infer<typeof notificationSchema>;
export type NotificationPreferencesParsed = z.infer<typeof notificationPreferencesSchema>;
